import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Zooplankton from '../../components/Zooplankton/Zooplankton';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardZooplankton extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Zooplankton/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Atlantic, Gulf of Mexico, Caribbean"
   diagnosis="Zooplankton play an important role in marine food webs, acting as carriers of energy from phytoplankton to higher trophic levels including fish, whales, crabs, shrimp, sea turtles and birds."
   prediction="Microplastics are clogging the digestive systems of zooplankton, which is hindering the transfer of energy up the food chain (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardZooplankton;
